"use strict";

export default angular.module("contartemx.bancos.cuentas_bancarias.perfil_cuenta", [
	'contartemx',
	'ui.router',
	'ngTable',
	'ui.bootstrap',
	'datePicker',
	"tableTools",
	"loader",
])

.controller("PerfilCuentaCtrl", function PerfilCuentaController($scope,$state,$stateParams,NgTableParams,$filter,$uibModal,callToWebService,dateTools,mostrarNotificacion) {
	$scope.CveCuentaPerfil = parseInt($stateParams.cveCuentaBanco);
	var filtroPerfil = { ClaveBanco: $scope.CveCuentaPerfil, IndiceInicial: 0, CantidadRegistrosSolicitados: 15 };
	$scope.llamadoInicial = 1;
	$scope.EstadoDeCuenta = [];

	$scope.$watch("llamadoInicial", function (params, paramsOld) {
		$scope.loading = true;
		callToWebService.postCall('ObtenerPantallaPerfilBanco', {filtro:filtroPerfil},
		function sucess(data){
			if(!data.EsError){
				$scope.DatosBanco = data.Respuesta.DatosBanco;
				$scope.EstaActivo = data.Respuesta.EstaActivo;
				$scope.NombreProveedor = data.Respuesta.NombreProveedor;
				$scope.RfcProveedor = data.Respuesta.RfcProveedor;
				$scope.SaldoTotal = data.Respuesta.SaldoTotal; 
				var EdoCuenta = data.Respuesta.EstadoDeCuenta;
				$scope.TipoCuenta = data.Respuesta.TipoCuenta;
				$scope.Monedas = data.Respuesta.Monedas;
				$scope.ListaBancos = data.Respuesta.ProveedoresBancarios;
				$scope.TipoCuentas = data.Respuesta.TiposDeBanco;
				$scope.CatalogoBancosSat = data.Respuesta.CatalogoBancosSAT;
				$scope.loading = false;
				$scope.cuentas = data.Respuesta.Cuentas;
				$scope.linkProveedor = data.Respuesta.ClaveCuenta;
				for(var m in $scope.Monedas) {
					if($scope.DatosBanco.ClaveMoneda == $scope.Monedas[m].CveMoneda){
					    $scope.CodigoMoneda = $scope.Monedas[m].Codigo;
					    $scope.cveMoneda = $scope.Monedas[m].CveMoneda;
					    if ($scope.Monedas[m].CveMoneda != 1) {
					        $scope.MonedaExt = $scope.Monedas[m].Valor;
					    }
						break;
					}
				}

				procesarEstadoDeCuenta(data.Respuesta);

				$scope.moreResults =  $scope.EstadoDeCuenta.length > 14;
				$scope.NoTieneTransacciones = $scope.EstadoDeCuenta.length < 1;
			}
			else{
				$scope.loading = false;
				mostrarNotificacion.error("La cuenta seleccionada no existe");
				$scope.errorGlobal = true;
			}
		},
		function error(data){
			errorHandler(data.Mensaje);
		});
	}, true);


	function procesarEstadoDeCuenta(data) {
      $scope.faltanResultados = data.FaltanResultados;

      if (angular.isArray(data.Movimientos)) {
        data.Movimientos.forEach(mov => mov.verCobroUrl = `index.html#/Clientes/Cobros/${(mov.ClaveAgrupacion ? 'CobrosMultiples' : 'Nuevo')}/${mov.ClaveAgrupacion ? mov.ClaveAgrupacion : mov.ClaveTransaccion}`);
      }

	    // remover aquellos que contengan puros 0's
      var registros = $filter('filter')(data.Movimientos, function (x) { return !(!x.Entrada && !x.Salida && !x.Total); });
		$scope.EstadoDeCuenta = $scope.EstadoDeCuenta.concat(registros);
		$scope.EstadoDeCuenta = $scope.tableParams.sorting ? $filter('orderBy')($scope.EstadoDeCuenta, $scope.tableParams.orderBy()) : registros;

	};

	$scope.showMore = function() {
		filtroPerfil.IndiceInicial++;
		llamarEstadoDeCuenta();
	};

    function llamarEstadoDeCuenta() {
		$scope.loading = true;
		callToWebService.postCall('ObtenerEstadoDeCuentaBanco', { filtro: filtroPerfil },
			function success(data){
				$scope.loading = false;
				if(data.EsError) {
					errorHandler(data.Mensaje);
					return;
				}
				procesarEstadoDeCuenta(data.Respuesta);
			},
			function error(data){
				errorHandler('Error');
			}
		);
	};

	var errorHandler = function(mensaje) {
		$scope.loading = false;
		mostrarNotificacion.error(mensaje);
	};

    $scope.mostrarCancelarPopPerfil = function(){
        for(var x = 0 ;x < $scope.EstadoDeCuenta.length ;x++){
            $(".popoverBancoPerfil[Indice='" + x + "']").addClass("popover--hidden");
        }
        var indexPop = $scope.selectedRow;   
        $(".popoverBancoPerfil[Indice='" + $scope.selectedRow + "']").removeClass("popover--hidden");
        $("#contextmenu").removeClass("open");
    };

	$scope.modalCuentasBancarias = function(){
		var modalInstance = $uibModal.open({
            template: require('../../../../../../app/views/Bancos/Cuentas_Bancarias/CuentaBancaria_modal.html'),
            controller: modalCuentasBancariasCtrl,
          windowClass: 'modal--small',
          openedClass: 'overflow-y-hidden',
          appendTo: angular.element(document.querySelector('.modal-parent')),
            resolve:{
            	listaBancos: function () {
					return $scope.ListaBancos;
				},
				tiposCuentas: function () {
					return $scope.TipoCuentas;
				},
				catalogoBancosSat: function() {
					return $scope.CatalogoBancosSat;
				},
				monedas: function () {
					return $scope.Monedas;
				},
				esMovil: function () {
					return $scope.Movil;
				},
				datosBanco: function(){
					return $scope.DatosBanco;
				}
            }
        });
        modalInstance.result.then(function (data) {
        	mostrarNotificacion.info(data.Mensaje);
        	$scope.llamadoInicial++;
		});
	};
    //modal nueva
	$scope.modalReexpresionCambiaria = function () {
	    var modalInstance = $uibModal.open({
          template: require('../../../../../../app/views/Bancos/Reexpresiones/Reexpresiones_modal.html'),
	        controller: modalReexpresionCtrl,
          windowClass: 'modal--small',
          openedClass: 'overflow-y-hidden',
          appendTo: angular.element(document.querySelector('.modal-parent')),
	        resolve: {
	            claveCuenta: function(){
	                return $scope.CveCuentaPerfil;
	            },
	            esTipo: function () {
	                return $scope.TipoCuenta;
	            },
	            proveedor: function () {
	                return $scope.NombreProveedor;
	            },
	            saldoTotal: function () {
	                return $scope.SaldoTotal;
	            },
	            monedaExt: function () {
	                return $scope.MonedaExt;
	            }
	        }
	    });
	    modalInstance.result.then(function (data) {
	        mostrarNotificacion.info(data.Mensaje);
	        $scope.llamadoInicial++;
	    });
	};
	
	var modalReexpresionCtrl = function ($scope, $uibModalInstance, esTipo, proveedor, saldoTotal, claveCuenta, monedaExt, callToWebService) {
	    $scope.tipoNombre = esTipo;
	    $scope.nombreProveedor = proveedor;
	    $scope.tc = monedaExt.toFixed(2);
	    $scope.saldo = saldoTotal;
	    $scope.fechaReexpresion = moment().format('DD/MM/YY');
	    $scope.closeModal = function (respuesta) {
	        $uibModalInstance.dismiss();
	    };
	    
	    $scope.guardarReexpresion = function (form) {
	        if (form.$valid) {
	            
	            var fechaReexp = $('#fechaReexpresion').val().split("/");
	            var anioFormatoYY = $('#fechaReexpresion').val().substr(6, 7);
	            var anioDosMil = "20";
	            var tipoCambio = form.tc.$viewValue ? form.tc.$viewValue : null;

	            var date = new Date(anioDosMil + anioFormatoYY, fechaReexp[1] - 1, fechaReexp[0]).toISOString().substring(0, 10);
	            var fechaMs = Date.parse(date);
	            var sqlStr = "/Date(" + fechaMs + ")/";

	            if (tipoCambio != 0 & tipoCambio != null) {
	                var enviarReexpresion = {
	                    CveCuenta: claveCuenta,
	                    TipoCambio: tipoCambio,
	                    TipoCambioProm: monedaExt,
	                    SaldoTotal: $scope.saldo,
	                    FechaReexpresion: sqlStr
	                };
	                callToWebService.postCall('ReexpresarMoneda', { filtro: enviarReexpresion },
	                function sucess(data) {
	                    if (data.CodigoRespuesta == 200) { 
	                        $uibModalInstance.close(data);
                          $state.reload();
	                    } else {
	                        $scope.alert = [];
	                        $scope.alert.push({ type: 'error', msg: data.Mensaje });
	                    }
	                },
	                function error(data) {
	                    $scope.alert = [];
	                    $scope.alert.push({ type: 'error', msg: data.Mensaje });
	                });
	            }
	            else {
	                $scope.alert = [];
	                $scope.alert.push({ type: 'error', msg: 'Faltan datos, ingresa los datos donde aparece el símbolo verde.' });
	            }
	        }
	    };
	};


	$scope.modalSaldo = function(){
		var modalInstance = $uibModal.open({
            template: require('../../../../../../app/views/Bancos/Cuentas_Bancarias/EditarSaldo_modal.html'),
            controller: modalSaldoCtrl,
          windowClass: 'modal--small',
          openedClass: 'overflow-y-hidden',
          appendTo: angular.element(document.querySelector('.modal-parent')),
            resolve:{
            	CuentaId: function () {
					return $scope.CveCuentaPerfil;
				},
				esMovil: function () {
					return $scope.Movil;
				}
            }
        });
        modalInstance.result.then(function (data) {
        	mostrarNotificacion.info("El saldo inical se actualizo correctamente");
			$scope.llamadoInicial++;
		});
	};

	var modalSaldoCtrl = function ($scope, $uibModalInstance, CuentaId, esMovil) {
	    
	    $scope.closeModal = function () {
			$uibModalInstance.dismiss();
		};

		callToWebService.postCall('ObtenerDatosBanco', {claveBanco: CuentaId},
        function sucess(data){
        	$scope.tipoCuenta = data.Respuesta.Tipo;
        	$scope.nombreCuenta = data.Respuesta.Nombre;
			$scope.saldo = data.Respuesta.Saldo;
			$scope.numeroCuenta = data.Respuesta.NumeroDeCuenta;
        	var obtenerFecha = data.Respuesta.FechaDeSaldoString;
        	if(esMovil)
    		{
    			$scope.transactionDate = obtenerFecha.substring(6,10)+"-"+obtenerFecha.substring(3,5)+"-"+obtenerFecha.substring(0,2);
    		}else{
    			$scope.transactionDate = obtenerFecha.substring(0,2)+"/"+obtenerFecha.substring(3,5)+"/"+obtenerFecha.substring(8,10);
    		}
        },
        function error(data){
        });
		$scope.saveChanges = function(f){
			var fecha;
			var saldo  = parseFloat(f.saldo.$viewValue);
			var fechaInput = $('#fechaSaldo').val();
			
			if(esMovil)
		        fecha = dateTools.getTimeForWCF(fechaInput,'YYYY-MM-DD');
		    else
		        fecha = dateTools.getTimeForWCF(fechaInput,'DD/MM/YY');

			var datosEnviar = {
				banco:{
					ClaveBanco : CuentaId,
					FechaDeSaldo: fecha,
					Saldo : saldo
				}
			};
	     	callToWebService.postCall("EditarSaldoInicial", datosEnviar,
	        function sucess(data){
	            if(data.EsError){
	            	$scope.alert = [];
					$scope.alert.push({
		              type: 'error',
		              msg: data.Mensaje
		            });
	            }
	            else {
	                $uibModalInstance.close(data);
                    //partial patch
	                setTimeout(function () { location.reload(); }, 1500);
	            }
	        },
	        function error(data){
	        	$scope.alert = [];
				$scope.alert.push({
	              type: 'error',
	              msg: data.Mensaje
	            });
	        });
		};
    };

	$scope.BorrarCobro = function(i){
		$scope.loading = true;

		var index;
		if($scope.selectedRow > 0)
			index = $scope.selectedRow;
		else
			index = i;

		var claveCancel = $scope.EstadoDeCuenta[index].ClaveCancelacion;
		callToWebService.postCall('BorrarCobroFactura', {cveTransaccionBuscada:claveCancel},
		function sucess(data){
			$scope.loading = false;
			mostrarNotificacion.info("Cobro Cancelado");
			$scope.EstadoDeCuenta = [];
			$scope.llamadoInicial++;
			//$scope.EstadoDeCuenta.splice(index, 1);
		},
		function error(data){
			$scope.loading = false;
			mostrarNotificacion.error(data.Mensaje);
		});	
	};

	$scope.CancelarPago = function(i){
		$scope.loading = true;
		var index;
		if($scope.selectedRow > 0)
			index = $scope.selectedRow;
		else
			index = i;

		var claveCancel = $scope.EstadoDeCuenta[index].ClaveCancelacion;
		callToWebService.postCall('CancelarPago', {ClavePago:claveCancel},
		function sucess(data){
			$scope.loading = false;
			mostrarNotificacion.info("Pago Cancelado");
			$scope.EstadoDeCuenta = [];
			$scope.llamadoInicial++;
			//$scope.EstadoDeCuenta.splice(index, 1);
		},
		function error(data){
			$scope.loading = false;
			mostrarNotificacion.error(data.Mensaje);
		});	
	};

    var modalCuentasBancariasCtrl = function ($scope, $uibModalInstance, listaBancos, tiposCuentas, monedas, esMovil, datosBanco, catalogoBancosSat) {
    	
	    $scope.closeModal = function () {
			$uibModalInstance.dismiss(false);
		};

		$scope.esNueva = 'Editar ';
		$scope.esCuentaNueva = false;	
		$scope.Undefined = true;
		$scope.Monedas = monedas;
		$scope.moneda = datosBanco.ClaveMoneda;
		$scope.ListTipoCuentas = tiposCuentas;
		$scope.ListaBancos = listaBancos;
		$scope.tipoCuenta = datosBanco.Tipo;
		$scope.CatalogoBancosSat = catalogoBancosSat;
		$scope.claveBancoSat = datosBanco.ClaveBancoSAT;
		var obtenerFecha = datosBanco.FechaDeSaldoString;
		$scope.ListaBancos.ClaveProveedor = datosBanco;
    	if(esMovil)
		{
			$scope.transactionDate = obtenerFecha.substring(6,10)+"-"+obtenerFecha.substring(3,5)+"-"+obtenerFecha.substring(0,2);
		}else{
			$scope.transactionDate = obtenerFecha.substring(0,2)+"/"+obtenerFecha.substring(3,5)+"/"+obtenerFecha.substring(8,10);
		}
		if($scope.tipoCuenta == 1010000 && $scope.tipoCuenta > 1){
            $scope.nombreCuenta = datosBanco.Nombre;
        }
        else if($scope.tipoCuenta != 1010000 && $scope.tipoCuenta > 1){
            $scope.numeroCuenta = datosBanco.NumeroDeCuenta;
  			$scope.Undefined = false;          
        }

		$scope.$watch("tipoCuenta", function (params, paramsOld) {
			if(!angular.isUndefined(params)){
				if(params != paramsOld){
					if(params == 1010000){
						$scope.Undefined = true;
					}else{
						$scope.Undefined = false;
					}
				}
			}
		}, true);

		$scope.saldo = datosBanco.Saldo;

		$scope.$watch("saldo", function (params) {
			if(!angular.isUndefined(params)){
				var num = parseFloat(params);
				if(num)
					$scope.mostrarFecha = true;
				else
					$scope.mostrarFecha = false;
			}
		}, true);

		$scope.$watch("ListaBancos.ClaveProveedor", function (params) {
			if(!angular.isUndefined(params))
				$scope.ClaveProveedor = params.ClaveProveedor;
		}, true);
		
		$scope.saveChanges = function(f){
			
			var fecha;
			var nombre;
			var numeroCuenta;
			var saldo;
			var fechaInput = $('#fechaSaldo').val();
			if($scope.mostrarFecha){
				if(esMovil)
			        fecha = dateTools.getTimeForWCF(fechaInput,'YYYY-MM-DD');
			    else
			        fecha = dateTools.getTimeForWCF(fechaInput,'DD/MM/YY');
			}
			else{
				if(esMovil)
			        fecha = dateTools.getTimeForWCF(fechaInput,'YYYY-MM-DD');
			    else
			        fecha = dateTools.getTimeForWCF(fechaInput,'DD/MM/YY');
			}
			if($scope.Undefined){
				nombre = f.nombreCuenta.$viewValue;
				numeroCuenta = 0;
			}
			else{
				nombre = f.bancoSelect.$viewValue;
				numeroCuenta = f.numeroCuenta.$viewValue;
			}
			if(f.saldo.$viewValue)
				saldo = parseFloat(f.saldo.$viewValue);
			else
				saldo = 0;
			
			var datosEnviar = {banco:{
				ClaveBanco : datosBanco.ClaveBanco,
				Nombre : nombre,
				ClaveMoneda: f.moneda.$viewValue,
				FechaDeSaldo: fecha,
				Tipo : f.tipoCuenta.$viewValue,
				Saldo : saldo,
				NumeroDeCuenta : numeroCuenta,
				ClaveProveedor : $scope.ClaveProveedor ? $scope.ClaveProveedor : null,
				ClaveBancoSAT : $scope.claveBancoSat
			}};
			
	     	callToWebService.postCall('EditarBanco', datosEnviar,
	        function sucess(data){
	            $uibModalInstance.close(data);
	        },
	        function error(data){
	            mostrarNotificacion.error(data.Mensaje);
	        });
		};
    };

    $scope.desactivarBanco = function(){
		$scope.loading = true;
		
		callToWebService.postCall('DesactivarBanco', { claveBanco: $scope.CveCuentaPerfil},
		function sucess(data){			
			if(data.CodigoRespuesta == 300 && data.EsError)
			{
				$scope.modalConfirmarDesactivar();
			}
			else{
				mostrarNotificacion.error(data.Mensaje);
			}
			$scope.loading = false;
		},
		function error(data){
			$scope.loading = false;
		});
	};

    $scope.cancelarTraspaso = function (i) {
		$scope.loading = true;
		var index;
		if($scope.selectedRow > 0)
			index = $scope.selectedRow;
		else
			index = i;

		var claveCancel = $scope.EstadoDeCuenta[index].ClaveCancelacion;
		callToWebService.postCall('CancelarTraspaso', { claveTraspaso: claveCancel},
		function sucess(data){
			if(data.EsError)
				mostrarNotificacion.error(data.Mensaje);
			else {
			    mostrarNotificacion.info(data.Mensaje);
			    $scope.EstadoDeCuenta.splice(index, 1);
			}

			$scope.loading = false;
			$scope.EstadoDeCuenta = [];
			filtroPerfil.IndiceInicial = 0;
			$scope.llamadoInicial++;

		},
		function error(data){
			$scope.loading = false;
			mostrarNotificacion.error(data.Mensaje);
		});
	};

    $scope.cancelarMovimiento = function (i) {
        debugger;
		$scope.loading = true;
		var index;
		if($scope.selectedRow > 0)
			index = $scope.selectedRow;
		else
			index = i;

		var claveCancel = $scope.EstadoDeCuenta[index].ClaveCancelacion;
		callToWebService.postCall('CancelarMovimientoNoIdentificado', { claveTraspaso: claveCancel},
		function sucess(data){
			if(data.EsError)
				mostrarNotificacion.error(data.Mensaje);
			else{
			    mostrarNotificacion.info(data.Mensaje);
			    $scope.EstadoDeCuenta.splice(index, 1);
			}
			$scope.loading = false;
			$scope.EstadoDeCuenta = [];
			filtroPerfil.IndiceInicial = 0;
			$scope.llamadoInicial++;
		},
		function error(data){
			$scope.loading = false;
			mostrarNotificacion.error(data.Mensaje);
		});
	};

	$scope.modalConfirmarDesactivar = function(){
		var modalInstance = $uibModal.open({
            template: require('../../../../../../app/views/Bancos/Cuentas_Bancarias/DesactivarConfirmar_modal.html'),
            controller: modalDesactivarCuentaCtrl,
            windowClass: 'modal--small',
            resolve:{
				ClaveBanco: function(){
					return $scope.CveCuentaPerfil;
				}
            }
        });
        modalInstance.result.then(function (data) {
        	mostrarNotificacion.info(data.Mensaje);
        	$scope.llamadoInicial++;        	
		});
	};

    var modalDesactivarCuentaCtrl = function ($scope, $uibModalInstance, ClaveBanco) {
    	$scope.confirmarDesactivacion = function(){
			callToWebService.postCall('DesactivarBanco', { claveBanco: ClaveBanco, ignorarConfirm: true},
			function sucess(data){
				 $uibModalInstance.close(data);
			},
			function error(data){
				
			});
    	};

		$scope.closeModal = function (respuesta) {
			$uibModalInstance.dismiss();
		};
    };


    $scope.displayPopupEgresos = function(){
		var modalInstance = $uibModal.open({
            template: require('../../../../../../app/views/Bancos/Cuentas_Bancarias/Egresos_modal.html'),
            controller: modalEgresosCtrl,
          windowClass: 'modal--small',
          openedClass: 'overflow-y-hidden',
          appendTo: angular.element(document.querySelector('.modal-parent')),
            resolve:{
				Banco: function(){
					return $scope.DatosBanco;
				},
				NombreTipo: function(){
					return $scope.TipoCuenta;
				},
				Monedas: function(){
					return $scope.Monedas;
				},
				Movil: function(){
					return $scope.Movil;
				}
            }
        });
		modalInstance.result.then(function (data) {
		    mostrarNotificacion.info(data.Mensaje);
		    filtroPerfil.IndiceInicial = 0;
		    $scope.EstadoDeCuenta = [];
        	$scope.llamadoInicial++;        	
		});
	};

    var modalEgresosCtrl = function ($scope, $uibModalInstance, Banco, NombreTipo, Monedas, Movil) {
    	$scope.tipoCuenta = Banco.Tipo;
    	$scope.tipoNombre = NombreTipo;
    	$scope.bancoNombre = Banco.Nombre;
    	var nombre;
    	var nombre2;
    	if($scope.tipoCuenta == 2011000){
    		nombre = 'Abono no identificado';
    		nombre2 = 'Consumo no identificado';
    	}
    	else{
    		nombre2 = 'Entrada no identificado';
    		nombre = 'Salida no identificado';
    	}
    	$scope.tipos = [{value:"false",nombre:nombre},{value:"true",nombre:nombre2}];
    	$scope.tipo = $scope.tipos[0].value;
    	for(var m in Monedas){
    		if(Banco.ClaveMoneda == Monedas[m].CveMoneda){
    			$scope.codigoMoneda = Monedas[m].Codigo;
    			break;
    		}
    	}
    	if(Movil){
    		$scope.fechaSaldo = moment().format('YYYY-MM-DD');
    	}
    	else
    	{
    		$scope.fechaSaldo = moment().format('DD/MM/YY');
    	}
    	$scope.saveData = function (f) {
    	    $("#guardarEgreso").css("display", "none");
    		var monto = parseFloat(f.monto.$viewValue);
    		var tipo = f.tipo.$viewValue;
    		var fecha = $('#fechaSaldo').val();
    		var descripcion = f.descripcion.$viewValue;
    		var fechaEnviar;
    		if(Movil){
    			fechaEnviar = dateTools.getTimeForWCF(fecha,'YYYY-MM-DD');
    		}
    		else
    		{
    			fechaEnviar = dateTools.getTimeForWCF(fecha,'DD/MM/YY');
    		}

    		if(tipo == "true")
    			tipo = true;
    		else
    			tipo = false;
    		if(monto != 0){
    			var datos = {
	    			Monto:monto,
	    			ClaveBanco:Banco.ClaveBanco,
	    			Fecha:fechaEnviar,
	    			EsEntrada:tipo,
	    			Descripcion: descripcion
	    		};
	    		callToWebService.postCall('GenerarMovimientoBancoNoIdentificado', { movimiento:datos },
				function sucess(data){
					 $uibModalInstance.close(data);
				},
				function error(data){
					$scope.alert = [];
                	$scope.alert.push({ type: 'error', msg: data.Mensaje});
				});
    		}
    		else{
    			$scope.alert = [];
                $scope.alert.push({ type: 'error', msg: "El monto debe ser diferente de cero"});
    		}
			
    	};

		$scope.closeModal = function (respuesta) {
			$uibModalInstance.dismiss();
		};
    };

    $scope.reactivarBanco = function(){
		$scope.loading = true;
		callToWebService.postCall('ReactivarBanco', { claveBanco: $scope.CveCuentaPerfil},
		function sucess(data){
			if(data.CodigoRespuesta == 200){
				mostrarNotificacion.info("El banco fue activado");
				$scope.llamadoInicial++;
			}
			$scope.loading = false;
		},
		function error(data){
			$scope.loading = false;
		});
	};

    $scope.select = function (index) {
		$scope.selectedRow = index;
	};

	$scope.deselect = function () {
		$scope.selectedRow = -1;
	};

	$scope.cleanFields = function () {
       $scope.fromDate = "";
       $scope.toDate = "";
       $scope.referencia = "";
       $scope.nombre = "";
       $scope.concepto = "";
       $('#toDate').val("");
       $('#fromDate').val("");
    };

    $scope.addSearchCriteria = function (f,opc) {
    	// Resetear Indice Inicial
    	var fromDate;
    	var toDate;
		var fromDateString = $('#fromDate').val();
		if(fromDateString){
			if($scope.Movil)
				fromDate = dateTools.getTimeForWCF(fromDateString,'YYYY-MM-DD');
			else
				fromDate = dateTools.getTimeForWCF(fromDateString,'DD/MM/YY');
		}
		var toDateString = $('#toDate').val();
		if (toDateString) {
			if($scope.Movil)
				toDate = dateTools.getTimeForWCF(toDateString,'YYYY-MM-DD');
			else
				toDate = dateTools.getTimeForWCF(toDateString,'DD/MM/YY');
		}
       var referencia = f.referencia.$viewValue;
       var nombre = f.nombre.$viewValue;
       var concepto = f.concepto.$viewValue;
    	if(opc){
    		if(referencia || nombre || concepto || fromDate || toDate){
				filtroPerfil = {
					ClaveBanco: $scope.CveCuentaPerfil,
					FechaInicial: fromDate,
					FechaFinal: toDate,
					Referencia: referencia,
					Nombre: nombre,
					Concepto: concepto,
					CantidadRegistrosSolicitados: 15,
					IndiceInicial: 0
				};
			}
			else{
				return false;
			}
    	}
    	else{
			$scope.cleanFields();
			filtroPerfil = { ClaveBanco: $scope.CveCuentaPerfil, CantidadRegistrosSolicitados: 15, Indice: 0 };
    	}
    	$scope.filtroPerfil = filtroPerfil;
		$scope.EstadoDeCuenta = [];
    	llamarEstadoDeCuenta();
    };
    
	$scope.tableParams = new NgTableParams({
		page: 1,
		count: 15,
		sorting: {
			DateSortValue: "asc"
		}
	});

	$scope.$watch("tableParams", function (params, paramsOld) {
		if(params != paramsOld){
			var orderedData = $scope.tableParams.sorting ? $filter('orderBy')($scope.EstadoDeCuenta, $scope.tableParams.orderBy()) : $scope.EstadoDeCuenta;
			$scope.EstadoDeCuenta = orderedData.slice(($scope.tableParams.page() - 1) * $scope.tableParams.count(), $scope.tableParams.page() * $scope.tableParams.count());
			$scope.EstadoDeCuenta = orderedData;
		}
	}, true);


	$scope.displayPopup = function () {
        var modalInstance = $uibModal.open({
            template: require('../../../../../../app/views/Bancos/Traspasos/Traspasos_modal.html'),
            controller: TraspasosModalCtrl,
          windowClass: 'modal--small',
          openedClass: 'overflow-y-hidden',
          appendTo: angular.element(document.querySelector('.modal-parent')),
            resolve:{
                cuentas: function(){
                    return $scope.cuentas;
                },
                monedas: function(){
                    return $scope.Monedas;
                },
                esMovil: function () {
                    return $scope.Movil;
                },
                indice: function(){
                	return $scope.CveCuentaPerfil;
                }
            }
        });
        modalInstance.result.then(function (data) {
        	if(data)
            {
        	    mostrarNotificacion.info(data.Mensaje);
        	    $scope.EstadoDeCuenta = [];
        	    filtroPerfil.IndiceInicial = 0;
            	$scope.llamadoInicial++;
            }
        });
    };

    var TraspasosModalCtrl = function ($scope, $uibModalInstance, callToWebService, cuentas, monedas, esMovil, indice) {
        if (indice) {
        	$scope.valOrigen = indice;
        }

         $scope.cuentasTraspaso = cuentas;
        for(var i in $scope.cuentasTraspaso){
            var clv = $scope.cuentasTraspaso[i].NumeroDeCuenta.toString();
            if(clv != 0 && clv.length > 3)
                $scope.cuentasTraspaso[i].NumeroDeCuenta = clv.substr(clv.length-4);
            else 
                $scope.cuentasTraspaso[i].NumeroDeCuenta = clv;
        }
        if(esMovil)
        {
            $scope.Movil = true;
            $scope.fechaTraspaso = moment().format('YYYY-MM-DD');
        }else{
            $scope.Movil = false;
            $scope.fechaTraspaso = moment().format('DD/MM/YY');
        }
        $scope.monedasTraspaso = monedas;

        $scope.monedaActual = {};
        $scope.monedaActual.Codigo = 'MXN';
        $scope.monedaActual.CveMoneda = 1;
        $scope.$watch('monedaActual', function (moneda) {
            var cve = $scope.monedaActual.CveMoneda;
            for (var n = 0; n < $scope.monedasTraspaso.length; n++) {
                if (cve == $scope.monedasTraspaso[n].CveMoneda) {
                  
                    $scope.tipoDeCambioActivo = $scope.monedasTraspaso[n].Valor.toFixed(2);
                    $scope.cveMonedaTraspaso = $scope.monedasTraspaso[n].CveMoneda;
                }
            }
        });

        $scope.valDestino = '';
        $scope.closeModal = function () {
            $uibModalInstance.close(null);
        };

        $scope.closeModalAlert = function (i) {
            $scope.alert.splice(i, 1);
        };

        $scope.cuentaDestino = function(nom){
            $scope.valDestino = nom;
        };

        $scope.cuentaOrigen = function(nom){
            $scope.valOrigen = nom;
        };

        $scope.ImporteSalidaOnChange = function () {
            if ( $scope.importeDestinoCodigo != '' ) {
                if ( $scope.codMonedasMXN || $scope.sonMonedasIguales ) {
                    $scope.importeDestinoValue = $scope.importe;
                }
            }
        };

        $scope.TipoCambioOrigenOnChange = function () {
            if ( $scope.TipoCambioOrigen != '' ) {
                if ( $scope.codMonedaOrigenMXN ) {
                    $scope.TipoCambioOrigen = 1;
                    $scope.TipoCambio = 1;
                }
                if ( $scope.sonMonedasIguales ) {
                    $scope.TipoCambio = $scope.TipoCambioOrigen;
                }
            }
        };

        $scope.TipoCambioOnChange = function () {
            if ( ( $scope.TipoCambioOrigen !== "" ) && ( $scope.importe !== "" ) ) {
                if ( $scope.codMonedaDestinoMXN ) {
                    $scope.TipoCambio = 1;
                }
                $scope.Equivalencia = ( $scope.TipoCambioOrigen / $scope.TipoCambio ).toFixed(10);
                $scope.importeDestinoValue = ( ( $scope.Equivalencia * $scope.TipoCambio ) * ( $scope.importe / $scope.TipoCambio ) ).toFixed(6);
            }
        };

        $scope.ImporteDestinoOnChange = function () {
            if ( ( $scope.importe !== "" ) && ( $scope.importeDestinoValue !== "" ) ) {
                $scope.TipoCambio = ($scope.codMonedaDestinoMXN ) ? 1 : ((($scope.importe*$scope.TipoCambioOrigen) / $scope.importeDestinoValue).toFixed(6));
                $scope.Equivalencia = ( $scope.TipoCambioOrigen / $scope.TipoCambio ).toFixed(10);
            }
        };

        $scope.invertirOrigen = function(){ 
            var origenSelected = $scope.valOrigen;
            var destinoSelected = $scope.valDestino;
            $scope.valOrigen = destinoSelected;
            $scope.valDestino = origenSelected;
        };

        $scope.importeDestino = false; 
        $scope.importeOrigenCodigo = "";
        $scope.importeDestinoCodigo = "";

        //
        $scope.sonMonedasIguales = false;
        $scope.codMonedaOrigenMXN = false;
        $scope.codMonedaDestinoMXN = false;
        $scope.codMonedasMXN = false;

        //
        $scope.$watch('valOrigen', function (params, paramsOld) {
            if(params != "") {
                for(var x = 0;x < $scope.cuentasTraspaso.length;x++){
                    if(params == $scope.cuentasTraspaso[x].CveCuentaDeBanco){
                        for(var m = 0 ; m<monedas.length ; m++){
                            if($scope.cuentasTraspaso[x].CveMoneda == monedas[m].CveMoneda){
                                $scope.importeOrigenCodigo = monedas[m].Codigo;
                            }
                        }
                    }
                }
                if($scope.importeOrigenCodigo != $scope.importeDestinoCodigo){
                    if($scope.valOrigen == "" || $scope.valDestino ==""){
                        $scope.sonMonedasIguales = true;
                    }
                    else{
                        $scope.sonMonedasIguales = false;
                    }
                }
                else{
                    $scope.sonMonedasIguales = true;
                }
            }
            else{
                $scope.importeOrigenCodigo = "";
                $scope.sonMonedasIguales = true;
            }
            if( params == undefined)
            {
                $scope.sonMonedasIguales = true;
            }

            //
            $scope.codMonedaOrigenMXN = $scope.importeOrigenCodigo == "MXN";
            $scope.importe = "";
            $scope.TipoCambioOrigen = ( $scope.importeOrigenCodigo == "MXN") ? "1" : "";
        });

        //
        $scope.$watch('valDestino', function (params, paramsOld) {
            if(params != "") {
                for(var x = 0;x < $scope.cuentasTraspaso.length;x++){
                    if(params == $scope.cuentasTraspaso[x].CveCuentaDeBanco){
                        for(var m = 0 ; m<monedas.length ; m++){
                            if($scope.cuentasTraspaso[x].CveMoneda == monedas[m].CveMoneda){
                                $scope.importeDestinoCodigo = monedas[m].Codigo;
                            }
                        }
                    }
                }
                if($scope.importeOrigenCodigo != $scope.importeDestinoCodigo){
                    if($scope.valOrigen == "" || $scope.valDestino ==""){
                        $scope.sonMonedasIguales = true;
                    }
                    else{
                        $scope.sonMonedasIguales = false;
                    }
                }
                else{
                    $scope.sonMonedasIguales = true;
                }
            }
            else{
                $scope.importeDestinoCodigo = "";
                $scope.sonMonedasIguales = true;
            }
            if( params == undefined)
            {
                $scope.sonMonedasIguales = true;
            }

            //
            $scope.codMonedaDestinoMXN = $scope.importeDestinoCodigo == "MXN";
            $scope.Equivalencia = "";
            $scope.importeDestinoValue = "";
            $scope.TipoCambio = ( $scope.importeDestinoCodigo == "MXN") ? "1" : "";
            if ($scope.sonMonedasIguales) {
                $scope.ImporteSalidaOnChange();
                $scope.TipoCambioOrigenOnChange();
                $scope.TipoCambioOnChange();
                $scope.ImporteDestinoOnChange();
            }
        });

        $scope.guardarTraspaso = function (form) {
            debugger;
            var monedaTipoCambioValidos = false;
            if(form.$valid){
                var ctaOrigen = form.cuentaOrigen.$viewValue ? form.cuentaOrigen.$viewValue : null;
                var ctaDestino = form.cuentaDestino.$viewValue ? form.cuentaDestino.$viewValue : null;
                var importeTraspaso = form.importe.$viewValue ? form.importe.$viewValue : null;
                var importeDestinoValue = form.importeDestinoValue.$viewValue ? form.importeDestinoValue.$viewValue : null;
                var TipoCambio = form.TipoCambio.$viewValue ? form.TipoCambio.$viewValue : null;
                if($scope.sonMonedasIguales)
                {
                    importeDestinoValue = importeTraspaso;
                }
                var fechaTraspaso = $('#fechaTraspaso').val();
                //tras modal
                var descripcionTraspaso = form.descripcion.$viewValue ? form.descripcion.$viewValue : null;
                var fecha;

                if(ctaOrigen && ctaDestino && importeTraspaso && importeDestinoValue && TipoCambio && fechaTraspaso){
        
                    if(ctaOrigen != ctaDestino){
                        if(esMovil)
                        fecha = dateTools.getTimeForWCF(fechaTraspaso,'YYYY-MM-DD');
                    else
                        fecha = dateTools.getTimeForWCF(fechaTraspaso,'DD/MM/YY');
                    var generarTraspaso = {
                        ClaveCuentaOrigen:ctaOrigen,
                        ClaveCuentaDestino:ctaDestino,
                        MontoOrigen:importeTraspaso,
                        MontoDestino:importeDestinoValue,
                        TipoCambio:TipoCambio,
                        Fecha:fecha,
                        Descripcion:descripcionTraspaso
                    };
                    callToWebService.postCall('GenerarTraspaso', { traspaso: generarTraspaso},
                    function sucess(data){
                        if(data.CodigoRespuesta == 200){
                            $uibModalInstance.close(data);
                        }else{
                            $scope.alert = [];
                            $scope.alert.push({ type: 'error', msg: data.Mensaje});
                        }
                        
                    },
                    function error(data){
                       $scope.alert = [];
                       $scope.alert.push({ type: 'error', msg: data.Mensaje});
                    });
                    }else{
                        $scope.alert = [];
                        $scope.alert.push({ type: 'error', msg: 'La cuentas Origen y Destino deben ser distintas.'});
                    }
                    
                }else{
                $scope.alert = [];
                $scope.alert.push({ type: 'error', msg: 'Faltan datos, ingresa los datos donde aparece el símbolo verde.'});
            
                }
            }
            else{
                $scope.alert = [];
                $scope.alert.push({ type: 'error', msg: 'Faltan datos, ingresa los datos donde aparece el símbolo verde.'});
            }
        };

    };

});
